import { render } from "./IMIVVitaminTherapiesContentPtBR.vue?vue&type=template&id=490a486a"
import script from "./IMIVVitaminTherapiesContentPtBR.vue?vue&type=script&lang=js"
export * from "./IMIVVitaminTherapiesContentPtBR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__